import axios from "axios";
import { ENDPOINTS } from "../../js/api/_config";

export class ImpersonateServices {
    static getImpersonateUsers() {
        return axios({
            method: 'GET',
            url: ENDPOINTS.USER.IMPERSONATE_USER + "list",
            headers: {
                'authorization': "Bearer " + localStorage.getItem("access-token")
            }
        }).then(e => {
            return e.data;
        }).catch(e => {
            return e.response !== undefined ? e.response.data : null;
        })
    }
}
